import script from "./WebsiteSolution.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsiteSolution.vue?vue&type=script&setup=true&lang=js"

import "./WebsiteSolution.vue?vue&type=style&index=0&id=2aa6d192&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aa6d192"]])

export default __exports__